import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lC5w8"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("6J1Ga"), parcelRequire.load("6qO4J"), parcelRequire.load("hkpo7"), parcelRequire.load("aKBno"), parcelRequire.load("gez6m"), parcelRequire.load("dwEcD"), parcelRequire.load("gTWSG"), parcelRequire.load("gzLGy"), parcelRequire.load("95APl")]).then(() => {
let originalModule = parcelRequire("i9ilt");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("6J1Ga")} />
  <link rel="modulepreload" href={parcelRequire.resolve("6qO4J")} />
  <link rel="modulepreload" href={parcelRequire.resolve("hkpo7")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lC5w8")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("aKBno")} />
  <link rel="modulepreload" href={parcelRequire.resolve("gez6m")} />
  <link rel="modulepreload" href={parcelRequire.resolve("dwEcD")} />
  <link rel="modulepreload" href={parcelRequire.resolve("gTWSG")} />
  <link rel="modulepreload" href={parcelRequire.resolve("gzLGy")} />
  <link rel="modulepreload" href={parcelRequire.resolve("95APl")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
